import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthComponentsModule } from '../../components';
import { ButtonsModule } from '@shared/core/components/buttons';
import { TwoColumnsModule } from '@shared/core/components/twoColumns';

import { AuthForRewardsAccountLinkingInfoComponent } from './auth-for-rewards-account-linking-info.shared.component';


@NgModule({
    declarations: [
        AuthForRewardsAccountLinkingInfoComponent
    ],
    imports: [
        CommonModule,
        ButtonsModule,
        AuthComponentsModule,
        TwoColumnsModule,
    ],
    exports: [
        AuthForRewardsAccountLinkingInfoComponent,
    ]
})
export class AuthForRewardsAccountLinkingInfoModule { }
